




















































import { Component, Prop, Watch } from 'vue-property-decorator';
import SaascadaVueProductForm from '@/components/Shared/SaascadaVueProductForm';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import ListUtils from '@/lib/listUtils';
import CreateTransactionalFeeRequest from '@/models/Products/ProductFees/CreateTransactionalFeeRequest';
import { SubTransactionTypesModule } from '@/store/Products/SubTransactionTypesModule';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';

@Component({ name: 'TransactionalFeesDialogForm', components: { FieldLabel } })
export default class extends SaascadaVueProductForm {

    @Prop({ default: false })
    transactionalFee: CreateTransactionalFeeRequest

    async beforeMount() {
        await SubTransactionTypesModule.getSubTransactionTypes();
    }

    @Watch('transactionalFee.transactionType')
    async onTransactionTypeChanged(transactionType: string) {
        if (transactionType) {
            this.transactionalFee.name = `${transactionType} (${this.transactionalFee.subTransactionType})`;
        }
    }

    @Watch('transactionalFee.subTransactionType')
    async onSubTransactionTypeChanged(subTransactionType: string) {
        if (subTransactionType) {
            this.transactionalFee.name = `${this.transactionalFee.transactionType} (${subTransactionType})`;
        }
    }

    get transactionTypeOptions() {
        return ListUtils.transactionTypeOptions();
    }

    get subTransactionTypeOptions() {
        return SubTransactionTypesModule.subTransactionTypes;
    }

    get defaultWalletCurrency() {
        return ProductDetailsModule.product.generalSettings.defaultWalletCurrency;
    }

}
